{
  "categories": [
    {
      "id": "ai",
      "fill_color": "#FC5757",
      "stroke_color": "#A63633",
      "en": "Artificial Intelligence",
      "fr": "Intelligence Artificielle"
    },
    {
      "id": "cloud",
      "fill_color": "#035266",
      "stroke_color": "#014554",
      "en": "Cloud & Infrastructure",
      "fr": "Cloud & Infrastructure"
    },
    {
      "id": "data",
      "fill_color": "#00C0DB",
      "stroke_color": "#00A0B0",
      "en": "Data Platform",
      "fr": "Plateforme Data"
    },
    {
      "id": "nocode",
      "fill_color": "#FF91F0",
      "stroke_color": "#EB73DE",
      "en": "No-Code / Low-code",
      "fr": "No-Code / Low-code"
    },
    {
      "id": "language",
      "fill_color": "#5D74FD",
      "stroke_color": "#3E4FC2",
      "en": "Programming Languages",
      "fr": "Langages de Programmation"
    },
    {
      "id": "security",
      "fill_color": "#F0B021",
      "stroke_color": "#D29614",
      "en": "Cyber-Security",
      "fr": "Cyber-Sécurité"
    }
  ],
  "skills": [
    {
      "growth": 1.06,
      "volume": 16440.361,
      "skill": "Java",
      "display_name": "Java",
      "part": 3.100774107478181,
      "category": "language",
      "en": "Java is a versatile, object-oriented programming language developed by Sun Microsystems (now Oracle). First released in 1995, it is widely used for building enterprise-level applications, mobile apps, and web services. Its key characteristic is the \"write once, run anywhere\" capability, enabling cross-platform compatibility.",
      "fr": "Java est un langage de programmation orienté objet polyvalent développé par Sun Microsystems (maintenant Oracle). Lancé pour la première fois en 1995, il est largement utilisé pour la création d'applications de niveau entreprise, d'applications mobiles et de services web. Sa caractéristique clé est la capacité \"write once, run anywhere\", permettant la compatibilité multiplateforme."
    },
    {
      "growth": 0.6699999999999999,
      "volume": 6200.335,
      "skill": "React.js",
      "display_name": "React.js",
      "part": 1.1694292008363276,
      "category": "language",
      "en": "React.js is a JavaScript library, released in 2013 by Facebook, for building dynamic user interfaces. It is widely adopted in web development, particularly for single-page applications, due to its component-based architecture and efficient virtual DOM for performance optimization.",
      "fr": "React.js est une bibliothèque JavaScript, publiée en 2013 par Facebook, pour construire des interfaces utilisateur dynamiques. Elle est largement adoptée dans le développement web, particulièrement pour les applications monopages (single-page applications), grâce à son architecture basée sur les composants et son DOM virtuel efficace pour l'optimisation des performances."
    },
    {
      "growth": 0.97,
      "volume": 5843.695,
      "skill": "Python",
      "display_name": "Python",
      "part": 1.1021642497996065,
      "category": "language",
      "en": "Python is an open-source, general-purpose programming language created by Guido van Rossum in 1991. It is widely used in web development, data science, and automation. Python's major characteristic is its readable syntax and extensive libraries, facilitating rapid application development across diverse domains.",
      "fr": "Python est un langage de programmation open-source, généraliste, créé par Guido van Rossum en 1991. Il est largement utilisé dans le web development, la data science et l'automation. La caractéristique majeure de Python est sa syntaxe lisible et ses bibliothèques étendues, facilitant le rapid application development à travers des domaines divers."
    },
    {
      "growth": 1.13,
      "volume": 3047.786,
      "skill": ".NET",
      "display_name": ".NET",
      "part": 0.5748350607346454,
      "category": "language",
      "en": ".NET Core is a free, open-source, cross-platform software development framework created by Microsoft. It enables the development of a wide range of applications, including web, mobile, and cloud services, offering high performance and modularity for modern software projects.",
      "fr": ".NET Core est un framework de développement logiciel gratuit, open-source et multiplateforme créé par Microsoft. Il permet le développement d'une large gamme d'applications, y compris les services web, mobiles et cloud, offrant des performances élevées et une modularité pour les projets logiciels modernes."
    },
    {
      "growth": 0.86,
      "volume": 2846.433,
      "skill": "JavaScript",
      "display_name": "JavaScript",
      "part": 0.5368583904618299,
      "category": "language",
      "en": "JavaScript is a high-level programming language, primarily used for web development to create dynamic and interactive content. First released in 1995 by Brendan Eich at Netscape, it is essential for modern front-end and back-end development, enabling rich user experiences across diverse platforms.",
      "fr": "JavaScript est un langage de programmation de haut niveau, principalement utilisé pour le développement web afin de créer du contenu dynamique et interactif. Sorti pour la première fois en 1995 par Brendan Eich chez Netscape, il est essentiel pour le développement front-end et back-end moderne, permettant des expériences utilisateur riches sur diverses plateformes."
    },
    {
      "growth": 0.88,
      "volume": 2604.958,
      "skill": "PHP",
      "display_name": "PHP",
      "part": 0.4913144131973834,
      "category": "language",
      "en": "PHP is a popular open-source scripting language primarily used for web development. Created by Rasmus Lerdorf in 1994, its main characteristic is its ability to be embedded directly into HTML, facilitating the creation of dynamic web pages and server-side applications.",
      "fr": "PHP est un langage de script open-source populaire principalement utilisé pour le développement web. Créé par Rasmus Lerdorf en 1994, sa caractéristique principale est sa capacité à être intégré directement dans le HTML, facilitant la création de pages web dynamiques et d'applications côté serveur."
    },
    {
      "growth": 0.83,
      "volume": 2541.06,
      "skill": "Angular",
      "display_name": "Angular",
      "part": 0.47926277613663754,
      "category": "language",
      "en": "Angular is an open-source, component-based web application framework developed by Google. Initially released in 2010, it is primarily used for building dynamic single-page applications and complex enterprise-level web solutions. Its key characteristic is its comprehensive tooling and opinionated structure, facilitating large-scale application development.",
      "fr": "Angular est un framework open-source, basé sur des composants, pour les applications web développé par Google. Initialement publié en 2010, il est principalement utilisé pour construire des applications dynamiques monopages et des solutions web complexes de niveau entreprise. Sa caractéristique clé est son outillage complet et sa structure opinionated, facilitant le développement d'applications à grande échelle."
    },
    {
      "growth": 0.76,
      "volume": 2330.048,
      "skill": "Flutter",
      "display_name": "Flutter",
      "part": 0.43946434677324425,
      "category": "language",
      "en": "Flutter is an open-source UI software development kit created by Google. Launched in 2017, it enables developers to build natively compiled applications for mobile, web, and desktop from a single codebase. Its major characteristic is the ability to deliver high-performance, visually attractive user interfaces with fast development cycles.",
      "fr": "Flutter est un kit de développement logiciel UI open-source créé par Google. Lancé en 2017, il permet aux développeurs de créer des applications compilées nativement pour mobile, web et desktop à partir d'une seule codebase. Sa caractéristique majeure est la capacité à fournir des interfaces utilisateur performantes et visuellement attrayantes avec des cycles de développement rapides."
    },
    {
      "growth": 1.17,
      "volume": 2015.759,
      "skill": "Next.js",
      "display_name": "Next.js",
      "part": 0.3801871086721338,
      "category": "language",
      "en": "Next.js is a JavaScript framework for building web applications, developed by Vercel. It enables server-side rendering and static site generation, offering developers a powerful tool for creating performant and scalable web experiences with a focus on developer experience and efficient routing.",
      "fr": "Next.js est un framework JavaScript pour la construction d'applications web, développé par Vercel. Il permet le server-side rendering et la static site generation, offrant aux développeurs un outil puissant pour créer des expériences web performantes et évolutives avec un focus sur la developer experience et un routing efficace."
    },
    {
      "growth": 0.7,
      "volume": 1653.918,
      "skill": "Vue.js",
      "display_name": "Vue.js",
      "part": 0.3119412104327939,
      "category": "language",
      "en": "Vue.js is an open-source JavaScript framework for building user interfaces and single-page applications, created by Evan You in 2014. It is known for its progressive nature, allowing developers to adopt it incrementally and integrate it into existing projects, facilitating efficient front-end development.",
      "fr": "Vue.js est un framework JavaScript open-source pour la construction d'interfaces utilisateur et d'applications monopages, créé par Evan You en 2014. Il est connu pour sa nature progressive, permettant aux développeurs de l'adopter progressivement et de l'intégrer dans des projets existants, facilitant ainsi le développement front-end efficace."
    },
    {
      "growth": 0.8,
      "volume": 1604.137,
      "skill": "React Native",
      "display_name": "React Native",
      "part": 0.3025521443505849,
      "category": "language",
      "en": "React Native is a JavaScript framework for building cross-platform mobile applications. Developed by Facebook, it enables developers to create native mobile apps for iOS and Android using a single codebase, significantly speeding up development and reducing costs.",
      "fr": "React Native est un JavaScript framework pour construire des applications mobiles cross-platform. Développé par Facebook, il permet aux développeurs de créer des applications mobiles natives pour iOS et Android en utilisant une single codebase, accélérant significativement le développement et réduisant les coûts."
    },
    {
      "growth": 0.96,
      "volume": 1480.799,
      "skill": "C++",
      "display_name": "C++",
      "part": 0.27928968211705224,
      "category": "language",
      "en": "C++ is a powerful, general-purpose programming language developed by Bjarne Stroustrup at Bell Labs, first released in 1985. It's widely used for system programming, game development, and high-performance applications, known for its efficiency and flexibility in managing hardware resources.",
      "fr": "C++ est un langage de programmation puissant et généraliste développé par Bjarne Stroustrup chez Bell Labs, sorti pour la première fois en 1985. Il est largement utilisé pour le system programming, le game development et les applications high-performance, connu pour son efficiency et sa flexibility dans la gestion des hardware resources."
    },
    {
      "growth": 0.6699999999999999,
      "volume": 1360.433,
      "skill": "Node.js",
      "display_name": "Node.js",
      "part": 0.25658776114215887,
      "category": "language",
      "en": "Node.js is an open-source, cross-platform JavaScript runtime environment created by Ryan Dahl in 2009. It allows developers to build scalable network applications using JavaScript on the server-side. Its event-driven, non-blocking I/O model makes it efficient for real-time applications and microservices.",
      "fr": "Node.js est un environnement d'exécution JavaScript open-source et multiplateforme créé par Ryan Dahl en 2009. Il permet aux développeurs de construire des applications réseau évolutives en utilisant JavaScript côté serveur. Son modèle d'E/S événementiel et non bloquant le rend efficace pour les applications en temps réel et les microservices."
    },
    {
      "growth": 0.75,
      "volume": 1088.495,
      "skill": "Golang",
      "display_name": "Go",
      "part": 0.20529823597665908,
      "category": "language",
      "en": "Go, also known as Golang, is an open-source programming language developed by Google and the open-source community. Introduced in 2009, it is designed for building efficient, reliable, and scalable software, particularly excelling in concurrent programming and cloud-native applications.",
      "fr": "Go, également connu sous le nom de Golang, est un langage de programmation open-source développé par Google et la communauté open-source. Introduit en 2009, il est conçu pour construire des logiciels efficaces, fiables et évolutifs, excellant particulièrement en programmation concurrente et en applications cloud-native."
    },
    {
      "growth": 1.26,
      "volume": 1073.635,
      "skill": "Kotlin",
      "display_name": "Kotlin",
      "part": 0.20249552968346235,
      "category": "language",
      "en": "Kotlin is a modern, statically-typed, general-purpose programming language developed by JetBrains starting in 2011. Designed to be fully interoperable with Java, it offers concise syntax and enhanced safety features, making it popular for Android development and server-side applications.",
      "fr": "Kotlin est un langage de programmation moderne, statiquement typé et généraliste développé par JetBrains à partir de 2011. Conçu pour être entièrement interopérable avec Java, il offre une syntaxe concise et des fonctionnalités de sécurité améliorées, ce qui le rend populaire pour le développement Android et les applications côté serveur."
    },
    {
      "growth": 0.73,
      "volume": 1062.49,
      "skill": "Ruby on Rails",
      "display_name": "Ruby",
      "part": 0.20039349996356484,
      "category": "language",
      "en": "Ruby on Rails is an open-source web application framework created by David Heinemeier Hansson in 2004. It emphasizes convention over configuration and the don't repeat yourself (DRY) principle, enabling developers to build sophisticated web applications quickly and efficiently.",
      "fr": "Ruby on Rails est un framework d'application web open-source créé par David Heinemeier Hansson en 2004. Il met l'accent sur la convention plutôt que sur la configuration et le principe \"don't repeat yourself\" (DRY), permettant aux développeurs de construire des applications web sophistiquées rapidement et efficacement."
    },
    {
      "growth": 0.55,
      "volume": 907.203,
      "skill": "Android",
      "display_name": "Android",
      "part": 0.17110521919965918,
      "category": "language",
      "en": "Android is an open-source operating system developed by Google, primarily for mobile devices. Launched in 2008, it powers a vast ecosystem of smartphones and tablets worldwide. Its major characteristic is its flexibility and extensive app support, making it a dominant platform in the mobile industry.",
      "fr": "Android est un système d'exploitation open-source développé par Google, principalement pour les appareils mobiles. Lancé en 2008, il alimente un vaste écosystème de smartphones et de tablettes dans le monde entier. Sa caractéristique majeure est sa flexibilité et son support d'applications étendu, ce qui en fait une plateforme dominante dans l'industrie mobile."
    },
    {
      "growth": 1.06,
      "volume": 840.333,
      "skill": "Rust",
      "display_name": "Rust",
      "part": 0.158493040880274,
      "category": "language",
      "en": "Rust is a modern, memory-safe systems programming language developed by Mozilla Research, first released in 2010. It prevents common programming errors like null pointer dereferences and buffer overflows without using a garbage collector, making it ideal for performance-critical applications such as operating systems and game engines.",
      "fr": "Rust est un langage de programmation système moderne et sûr en mémoire développé par Mozilla Research, sorti pour la première fois en 2010. Il empêche les erreurs de programmation courantes comme les null pointer dereferences et les buffer overflows sans utiliser de garbage collector, ce qui le rend idéal pour les applications critiques en termes de performance telles que les operating systems et les game engines."
    },
    {
      "growth": 0.47,
      "volume": 728.14,
      "skill": "C#",
      "display_name": "C#",
      "part": 0.13733260836663883,
      "category": "language",
      "en": "C# is a versatile, multi-paradigm programming language developed by Microsoft and first released in 2000. It excels in building a wide array of applications, from enterprise software and web services to mobile apps and game development, particularly within the .NET ecosystem.",
      "fr": "C# est un langage de programmation polyvalent et multi-paradigme développé par Microsoft et publié pour la première fois en 2000. Il excelle dans la création d'un large éventail d'applications, des logiciels d'entreprise et des services web aux applications mobiles et au développement de jeux, en particulier au sein de l'écosystème .NET."
    },
    {
      "growth": 0.78,
      "volume": 702.135,
      "skill": "Django",
      "display_name": "Django",
      "part": 0.13242787235354458,
      "category": "language",
      "en": "Django is a high-level Python web framework created in 2005 by Django Software Foundation. It enables rapid development of secure and maintainable websites by offering a comprehensive set of tools and libraries, emphasizing a DRY (Don't Repeat Yourself) principle.",
      "fr": "Django est un web framework Python de haut niveau créé en 2005 par la Django Software Foundation. Il permet le développement rapide de sites web sécurisés et maintenables en offrant un ensemble complet d'outils et de bibliothèques, en mettant l'accent sur le principe DRY (Don't Repeat Yourself)."
    },
    {
      "growth": 1.0,
      "volume": 569.138,
      "skill": "TypeScript",
      "display_name": "TypeScript",
      "part": 0.10734365102943402,
      "category": "language",
      "en": "TypeScript is a statically typed, general-purpose programming language developed by Microsoft. It is a superset of JavaScript, adding optional static typing and other features that compile down to plain JavaScript. Primarily used for large-scale web application development, it enhances code quality and maintainability.",
      "fr": "TypeScript est un langage de programmation statiquement typé et généraliste développé par Microsoft. C'est un sur-ensemble de JavaScript, ajoutant la typisation statique optionnelle et d'autres fonctionnalités qui se compilent en JavaScript simple. Principalement utilisé pour le développement d'applications web à grande échelle, il améliore la qualité et la maintenabilité du code."
    },
    {
      "growth": 1.1,
      "volume": 435.398,
      "skill": "Spring Boot",
      "display_name": "Spring Boot",
      "part": 0.08211929439066362,
      "category": "language",
      "en": "Spring Boot is a popular Java framework, first released in 2014, designed for building enterprise-grade applications. Created by Pivotal (now VMware), it simplifies the development of standalone Spring applications, emphasizing convention over configuration for rapid deployment and reduced complexity.",
      "fr": "Spring Boot est un framework Java populaire, sorti pour la première fois en 2014, conçu pour construire des applications de niveau entreprise. Créé par Pivotal (maintenant VMware), il simplifie le développement d'applications Spring autonomes, en privilégiant la convention plutôt que la configuration pour un déploiement rapide et une complexité réduite."
    },
    {
      "growth": 0.98,
      "volume": 429.454,
      "skill": "Nuxt.js",
      "display_name": "Nuxt.js",
      "part": 0.08099821187338493,
      "category": "language",
      "en": "Nuxt.js is a free, open-source JavaScript framework built on top of Vue.js. Created by Corentin Boyer and Sébastien Chopin in 2016, it simplifies the development of server-side rendering (SSR) and static web applications, enabling efficient creation of modern web experiences.",
      "fr": "Nuxt.js est un framework JavaScript gratuit et open-source construit sur Vue.js. Créé par Corentin Boyer et Sébastien Chopin en 2016, il simplifie le développement d'applications server-side rendering (SSR) et statiques, permettant la création efficace d'expériences web modernes."
    },
    {
      "growth": 0.53,
      "volume": 231.073,
      "skill": "C (Programming Language)",
      "display_name": "C",
      "part": 0.04358208285920885,
      "category": "language",
      "en": "C is a general-purpose, procedural programming language developed by Dennis Ritchie at Bell Labs in 1972. It is foundational for system programming, embedded systems, and operating systems, known for its efficiency, low-level memory access, and portability.",
      "fr": "C est un langage de programmation procédural à usage général développé par Dennis Ritchie chez Bell Labs en 1972. Il est fondamental pour le system programming, les embedded systems et les operating systems, connu pour son efficacité, son accès à la mémoire de bas niveau et sa portabilité."
    },
    {
      "growth": 0.65,
      "volume": 216.956,
      "skill": "Scala",
      "display_name": "Scala",
      "part": 0.04091951188067198,
      "category": "language",
      "en": "Scala is a general-purpose programming language developed by Martin Odersky and first released in 2004. It combines object-oriented and functional programming paradigms, offering conciseness and scalability for building robust applications, particularly in big data and concurrent systems.",
      "fr": "Scala est un langage de programmation généraliste développé par Martin Odersky et publié pour la première fois en 2004. Il combine les paradigmes de programmation orientée objet et fonctionnelle, offrant concision et scalabilité pour la construction d'applications robustes, particulièrement dans les systèmes big data et concurrents."
    },
    {
      "growth": 0.6599999999999999,
      "volume": 153.058,
      "skill": "Spring Framework",
      "display_name": "Spring",
      "part": 0.028867874819926122,
      "category": "language",
      "en": "The Spring Framework is an open-source application framework for the Java platform, created by Rod Johnson and initially released in 2003. It simplifies enterprise Java development by providing a comprehensive programming and configuration model, enabling developers to build robust, scalable applications with increased productivity.",
      "fr": "Le Spring Framework est un framework d'application open-source pour la plateforme Java, créé par Rod Johnson et initialement publié en 2003. Il simplifie le développement Java d'entreprise en fournissant un modèle de programmation et de configuration complet, permettant aux développeurs de construire des applications robustes et évolutives avec une productivité accrue."
    },
    {
      "growth": 0.5,
      "volume": 117.394,
      "skill": "R",
      "display_name": "R",
      "part": 0.022141379716254014,
      "category": "language",
      "en": "R is a programming language and free software environment created by Ross Ihaka and Robert Gentleman in 1993. Primarily used for statistical analysis and data visualization, R is a powerful tool for data scientists and analysts, offering a wide array of statistical techniques and graphical representations.",
      "fr": "R est un langage de programmation et un environnement logiciel libre créé par Ross Ihaka et Robert Gentleman en 1993. Principalement utilisé pour l'analyse statistique et la visualisation de données, R est un outil puissant pour les data scientists et les analystes, offrant un large éventail de techniques statistiques et de représentations graphiques."
    },
    {
      "growth": 0.6,
      "volume": 100.30499999999999,
      "skill": "AngularJS",
      "display_name": "Angular",
      "part": 0.018918267479077797,
      "category": "language",
      "en": "AngularJS is an open-source web application framework developed by Google. Launched in 2010, it's designed for building dynamic, single-page applications. Its key characteristic is providing a robust structure for front-end development, enabling the creation of complex and interactive user interfaces.",
      "fr": "AngularJS est un framework d'application web open-source développé par Google. Lancé en 2010, il est conçu pour construire des applications dynamiques, single-page. Sa caractéristique clé est de fournir une structure robuste pour le développement front-end, permettant la création d'interfaces utilisateur complexes et interactives."
    },
    {
      "growth": 0.79,
      "volume": 56.467999999999996,
      "skill": "Express.js",
      "display_name": "Express.js",
      "part": 0.0106502839141475,
      "category": "language",
      "en": "Express.js is a minimalist, open-source web application framework for Node.js, created by TJ Holowaychuk in 2010. It simplifies the development of server-side web applications and APIs by providing a robust set of features for web and mobile applications, prioritizing simplicity and flexibility.",
      "fr": "Express.js est un framework d'application web minimaliste et open-source pour Node.js, créé par TJ Holowaychuk en 2010. Il simplifie le développement d'applications web et d'APIs côté serveur en fournissant un ensemble robuste de fonctionnalités pour les applications web et mobiles, en privilégiant la simplicité et la flexibilité."
    },
    {
      "growth": 0.7,
      "volume": 49.038,
      "skill": "GraphQL",
      "display_name": "GraphQL",
      "part": 0.009248930767549145,
      "category": "language",
      "en": "GraphQL is a data query language developed by Facebook. It provides a flexible and efficient way for clients to request exactly the data they need from APIs, enabling more efficient data fetching and reducing over-fetching.",
      "fr": "GraphQL est un langage de requête de données développé par Facebook. Il offre un moyen flexible et efficace pour les clients de demander exactement les données dont ils ont besoin à partir des API, permettant une récupération de données plus efficace et réduisant le sur-fetching."
    },
    {
      "growth": 0.71,
      "volume": 48.295,
      "skill": "Dart",
      "display_name": "Dart",
      "part": 0.00910879545288931,
      "category": "language",
      "en": "Dart is an open-source, object-oriented programming language developed by Google. Initially released in 2011, it is designed for client-optimized applications, excelling in web, server, and mobile development with its efficient compilation and flexible features for building scalable user interfaces.",
      "fr": "Dart est un langage de programmation orienté objet open-source développé par Google. Initialement publié en 2011, il est conçu pour les applications client-optimisées, excellant dans le développement web, serveur et mobile avec sa compilation efficace et ses fonctionnalités flexibles pour la construction d'interfaces utilisateur évolutives."
    },
    {
      "growth": 2.01,
      "volume": 16.346,
      "skill": "Python/Django",
      "display_name": "Django",
      "part": 0.0030829769225163817,
      "category": "language",
      "en": "Django is an open-source Python web framework, created in 2005 by Adrian Holovaty and Simon Willison. It facilitates the development of complex, database-driven websites by providing a robust set of tools and adhering to the Don't Repeat Yourself (DRY) principle, enabling rapid, clean, and maintainable code.",
      "fr": "Django est un framework web open-source en Python, créé en 2005 par Adrian Holovaty et Simon Willison. Il facilite le développement de sites web complexes et basés sur des bases de données en fournissant un ensemble d'outils robustes et en adhérant au principe Don't Repeat Yourself (DRY), permettant un code rapide, propre et maintenable."
    },
    {
      "growth": 0.5700000000000001,
      "volume": 9.659,
      "skill": "WebSocket",
      "display_name": "WebSocket",
      "part": 0.0018217590905778619,
      "category": "language",
      "en": "WebSocket is a computer network protocol enabling full-duplex communication over a single TCP connection. Developed by the IETF and standardized in 2011, it allows for real-time, bidirectional data exchange between clients and servers, crucial for interactive web applications and live data feeds.",
      "fr": "WebSocket est un protocole réseau informatique permettant une communication full-duplex sur une seule connexion TCP. Développé par l'IETF et standardisé en 2011, il permet un échange de données bidirectionnel en temps réel entre les clients et les serveurs, crucial pour les applications web interactives et les flux de données en direct."
    }
  ]
}